import { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { Button, Card, CardContent, Container, Skeleton, Stack, Typography } from '@mui/material';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';

import serviceOrdersApi from '../../api/serviceOrdersApi';
import { getErrorMessage } from '../../utils/errorHandler';
import CustomerServiceOrderCard from '../../sections/client/account/CustomerServiceOrderCard';

export default function ServiceOrderTrackingPage() {
  const { enqueueSnackbar } = useSnackbar();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadOrders = async () => {
      setLoading(true);
      try {
        const { data } = await serviceOrdersApi.getMyServiceOrders({ per_page: 50 });
        setOrders(data.data);
      } catch (error) {
        enqueueSnackbar(getErrorMessage(error, 'No se pudieron cargar tus órdenes de servicio.'), {
          variant: 'error',
        });
      } finally {
        setLoading(false);
      }
    };

    loadOrders();
  }, [enqueueSnackbar]);

  return (
    <Container maxWidth="md" sx={{ py: 5 }}>
      <Stack spacing={1} sx={{ mb: 4 }}>
        <Typography variant="h4">Mis órdenes de servicio</Typography>
        <Typography color="text.secondary">
          Seguimiento del estado de tus solicitudes: pendiente, contacto, recibido, en proceso y entregado.
        </Typography>
      </Stack>

      {loading && <Skeleton variant="rounded" height={180} />}

      {!loading && orders.length === 0 && (
        <Card>
          <CardContent>
            <Stack spacing={2} sx={{ alignItems: 'center', textAlign: 'center', py: 4 }}>
              <BuildOutlinedIcon sx={{ fontSize: 48, color: 'text.disabled' }} />
              <Typography variant="h6">Aún no tienes solicitudes de servicio</Typography>
              <Button variant="contained" component={RouterLink} to="/servicio-tecnico">
                Solicitar un servicio
              </Button>
            </Stack>
          </CardContent>
        </Card>
      )}

      <Stack spacing={2}>
        {orders.map((order) => (
          <CustomerServiceOrderCard key={order.id} order={order} />
        ))}
      </Stack>
    </Container>
  );
}
